import Fuse from 'fuse.js'
window.Fuse = Fuse
